import { Box, styled, Typography } from '@mui/joy';

export const TitleWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: 32,
  fontWeight: 500,
  lineHeight: '40px',
  color: theme.palette.neutral[900],
}));
